import { getFreddyLabels } from '../core/getFreddyLabels/getFreddyLabels.js';
import { useTranslation } from '../i18n/useTranslation.js';
export function useFreddyTranslations(componentName) {
    const { t } = useTranslation(componentName);
    return getFreddyLabels(componentName, t);
}
//# sourceMappingURL=index.js.map